import { PageId } from 'constants/pages'

export const enum PageIdWoofzK9Bl {
  DOG_AGE_K9_BL = PageId.DOG_AGE_K9_BL,
  DOG_SEX_K9_BL = PageId.DOG_SEX_K9_BL,
  DOG_BREED_K9_BL = PageId.DOG_BREED_K9_BL,
  DOG_BREED_ID_K9_BL = PageId.DOG_BREED_ID_K9_BL,
  URGE_K9_BL = PageId.URGE_K9_BL,
  CHALLENGES_K9_BL = PageId.CHALLENGES_K9_BL,
  URGE_1_K9_BL = PageId.URGE_1_K9_BL,
  LEASH_PULLING_K9_BL = PageId.LEASH_PULLING_K9_BL,
  URGE_LEASH_K9_BL = PageId.URGE_LEASH_K9_BL,
  DURING_WALK_K9_BL = PageId.DURING_WALK_K9_BL,
  URGE_NOT_ALONE_K9_BL = PageId.URGE_NOT_ALONE_K9_BL,
  AGRESSIVE_BEHAVIOR_K9_BL = PageId.AGRESSIVE_BEHAVIOR_K9_BL,
  TRIGGERS_K9_BL = PageId.TRIGGERS_K9_BL,
  URGE_2_K9_BL = PageId.URGE_2_K9_BL,
  BEHAVIOR_ISSUES_K9_BL = PageId.BEHAVIOR_ISSUES_K9_BL,
  DOG_ACT_K9_BL = PageId.DOG_ACT_K9_BL,
  DOG_OFF_AT_HOME_K9_BL = PageId.DOG_OFF_AT_HOME_K9_BL,
  REWARDS_K9_BL = PageId.REWARDS_K9_BL,
  IGNORE_COMMANDS_K9_BL = PageId.IGNORE_COMMANDS_K9_BL,
  COMMANDS_61_K9_BL = PageId.COMMANDS_61_K9_BL,
  COMMANDS_62_K9_BL = PageId.COMMANDS_62_K9_BL,
  COMMANDS_63_K9_BL = PageId.COMMANDS_63_K9_BL,
  URGE_3_K9_BL = PageId.URGE_3_K9_BL,
  PREPARE_SCREEN_K9_BL = PageId.PREPARE_SCREEN_K9_BL,
  DOG_PROFILE_K9_BL = PageId.DOG_PROFILE_K9_BL,
  URGE_REVIEWED_K9_BL = PageId.URGE_REVIEWED_K9_BL,
  SOCIAL_SCREEN_K9_BL = PageId.SOCIAL_SCREEN_K9_BL,
  PREPARE_FLOW_K9_BL = PageId.PREPARE_FLOW_K9_BL,
  EMAIL_K9_BL = PageId.EMAIL_K9_BL,
  NEWSLETTER_URGE_K9_BL = PageId.NEWSLETTER_URGE_K9_BL,
  DISCIPLINE_SCREEN_K9_BL = PageId.DISCIPLINE_SCREEN_K9_BL,
  SCRATCH_SCREEN_K9_BL = PageId.SCRATCH_SCREEN_K9_BL,
  SUBSCRIPTIONS_K9_BL = PageId.SUBSCRIPTIONS_K9_BL,
  CHAT_UPSELL_K9_BL = PageId.CHAT_UPSELL_K9_BL,
  UPSELL_K9_BL = PageId.UPSELL_K9_BL,
  UPSELL_FEEDING_GUIDE_K9_BL = PageId.UPSELL_FEEDING_GUIDE_K9_BL,
  UPSELL_EMOTIONAL_SUPPORT_K9_BL = PageId.UPSELL_EMOTIONAL_SUPPORT_K9_BL,
  DOWNLOAD_K9_BL = PageId.DOWNLOAD_K9_BL,
  ACCOUNT_K9_BL = PageId.ACCOUNT_K9_BL,
}
